export enum SnackbarType {
	Success = 'success',
	Warning = 'warning',
	Error = 'error',
	Mute = 'mute',
}
